import { render } from "./BlankLayout.vue?vue&type=template&id=8cfc8e8c"
const script = {}

import exportComponent from "/builds/partout-chez-nous/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__